// Причина отказа с узла (§4 контракта).
//
// Узел не просто отказывает — он говорит, почему: срок истёк, ссылка отозвана, уже использована,
// гостей не пускают. Для человека это четыре разных сообщения и четыре разных следующих шага, а
// «ссылка не работает» на все случаи превращает поддержку в гадание, а человека — в того, кто решил,
// что сломан продукт.
//
// Причина приезжает деталью `google.rpc.ErrorInfo`, а не текстом сообщения: текст меняется и
// переводится, а причина — часть контракта.

import { ConnectError } from "@connectrpc/connect";

const errorInfoType = "google.rpc.ErrorInfo";

/** Строковая причина отказа, например `LINK_EXPIRED`; `undefined` — узел причины не назвал. */
export function errorReason(err: unknown): string | undefined {
  if (!(err instanceof ConnectError)) {
    return undefined;
  }
  for (const detail of err.details) {
    const raw = detail as { type?: string; value?: Uint8Array };
    if (raw.type === errorInfoType && raw.value !== undefined) {
      const reason = firstStringField(raw.value);
      if (reason !== undefined) {
        return reason;
      }
    }
  }
  return undefined;
}

/**
 * Поле 1 (`reason`) из `ErrorInfo`, без генерации типов googleapis.
 *
 * Тянуть ради одной строки ещё одну генерацию контракта дороже, чем прочитать три байта заголовка:
 * тег `0x0A` — поле 1, тип «байты», дальше длина в varint и сама строка.
 */
function firstStringField(bytes: Uint8Array): string | undefined {
  if (bytes.length < 2 || bytes[0] !== 0x0a) {
    return undefined;
  }
  let at = 1;
  let length = 0;
  let shift = 0;
  while (at < bytes.length) {
    const byte = bytes[at] ?? 0;
    at += 1;
    length |= (byte & 0x7f) << shift;
    if ((byte & 0x80) === 0) {
      break;
    }
    shift += 7;
  }
  if (at + length > bytes.length) {
    return undefined;
  }
  return new TextDecoder().decode(bytes.subarray(at, at + length));
}
